import React, { useState } from "react";
import "./UserLogin.scss";
import { Row, Col } from "antd";
import { sessionService } from "../../Shared/Utils/SessionService";
import { VARIABLES } from "../../Environments/constants";
import LoginBg from "../../Assets/images/LoginPageNew.jpeg";
import { Image } from "antd";
import userLoginJson from "../../Assets/json/UserLogin.json";
import AntBuilder from "../../Shared/Components/Ant-FormBuilder/Ant-FormBuilder";
import { ServiceUtils } from "../../Shared/Utils/ServiceUtils";
import { alertService } from "../../Shared/Utils/ToasterUtils";
import { useHistory } from "react-router-dom";
import mainLogo from "../../Assets/images/CPCB_logo.png"
import CryptoJS from 'crypto-js';
export default function UserLogin(props) {
  const [credential, setCredential] = useState({
    user: "",
    password: "",
  });
  const history = useHistory();

  const hashPassword = (credential) => {
    console.log(credential?.user)
    console.log(credential?.password)
    try {
      let tokenFromUI = credential?.user?.slice(0, 3) + "QVY1bWdMQ0Zxc";
      const key = CryptoJS.enc.Utf8.parse(tokenFromUI);
      const iv = CryptoJS.lib.WordArray.random(16);
      console.log(iv)
      const encrypted = CryptoJS.AES.encrypt(credential?.password, key, {
        iv,
      });
      let encry = iv.concat(encrypted.ciphertext).toString(CryptoJS.enc.Base64);
      return encry;
    } catch (error) {
      console.log(error);
    }
  };
  const handleLogin = (action) => {
    if (action?.type === "onChange") {
      setCredential({ ...credential, ...action.payload.data });
    }
    if (action?.payload?.data?.key === "sign-in") {
      const encryPass = hashPassword(credential);
      
      const encodedPayload = btoa(JSON.stringify({ user: credential.user, password: encryPass }));
      ServiceUtils.postRequest("userLogin", encodedPayload).then(
        (response) => {
          let decodedData;
          if (response?.data) {
            decodedData = JSON.parse(atob(response.data))
          }
          if (response.status === 200 && decodedData?.status === "success") {
            const session = {
              [VARIABLES.userName]: decodedData?.body?.user_name,
              [VARIABLES.email]: decodedData?.body?.email,
              [VARIABLES.userId]: decodedData?.body?.user_id,
              [VARIABLES.org]: decodedData?.body?.org,
              [VARIABLES.name]: decodedData?.body?.name,
            };
            let role;
            try {
              role =
                decodedData?.body?.role?.map((el) => el?.toLowerCase()) ||
                [];
            } catch (e) {
              role = [];
            }
            session[VARIABLES.userRole] = role;
            sessionService.setSession(session, "cpcb-user");
            if ((role && role[0] === "state") || (role && role[0] === "state_admin")) {
              session['redirect'] = 'state-home';
            }
            else if (role && role[0] === "rdo") {
              session['redirect'] = 'ro-home';
            } else if (role && role[0] === "ulb") {
              session['redirect'] = 'complaints-list';
            } else if (role && role[0] === "all") {
              session['redirect'] = 'cpcb-home';
            }
            history.push(`/${session.redirect}`);
          } else {
            // sessionService.clearSession('sso-redirect');
            alertService.error(
              decodedData?.message || "Error while fetching user role."
            );
          }
        },
        (error) => {
          alertService.error("Error while fetching user role.");
          console.log("userLogin Error", error);
        }
      );
    }
  };
  return (
    <div className="login-root">
      <Row>
        <Col span={17} className="left-content">

          <Image
            rootClassName="bg-image"
            height="100%"
            // width="100vw"
            src={LoginBg}
            preview={false}
            alt="Login"
          />
          <div className="top-left">Single Use Plastic Public Grievance Portal</div>
        </Col>
        <Col><img className="logo" src={mainLogo} alt="" /></Col>


        <Row></Row>
        <Col span={7} className="right-content">
          <Row span={18} className="login-content">
            <div className="formCenter">
              <div className="subHeader">Sign In to your account</div>
              <AntBuilder
                config={userLoginJson}
                onAction={handleLogin}
                data={credential}
                className='login-form'
              />
            </div>
          </Row>
          <Row span={6} className="footer-content">

          </Row>
        </Col>
      </Row>
    </div>
  );
}
